import { IGetAssistenciaTecnicaByIdUseCase } from "../../../presentation/useCases/read/get_assistencia_tecnica_by_id_use_case";
import { AssistenciaTecnicaDetalhe } from "../../models/assistencia_tecnica_detalhe";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * GetAssistenciaTecnicaByIdUseCase
 */

export class GetAssistenciaTecnicaByIdUseCase implements IGetAssistenciaTecnicaByIdUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async getAssistenciaTecnicaById(
    idAssistenciaTecnica: number | undefined,
  ): Promise<AssistenciaTecnicaDetalhe> {
    if (idAssistenciaTecnica === undefined) {
      throw new Error("ID da assistência técnica não fornecido");
    }
    const result = await this.repository.getAssistenciaTecnicaById(idAssistenciaTecnica);
    if (!result) {
      throw new Error("Assistência técnica não encontrada");
    }
    return result;
  }
}
